module.exports = __webpack_public_path__ + "img/landingpage-video-mobile-people.2717be32.svg";